
    <ng-template #componentTarget></ng-template>
    <ng-content *ngIf="!_componentRef"></ng-content>
  


// WEBPACK FOOTER //
// ./~/@uirouter/angular/lib/directives/uiView.d.ts.UIView.html